// extracted by mini-css-extract-plugin
module.exports = {"ErrorMsgIcon":"new-password_ErrorMsgIcon__S5-ch","ErrorMsg":"new-password_ErrorMsg__VgbFf","InfoMsg":"new-password_InfoMsg__31iFo","Icon":"new-password_Icon__39szA"};